import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { usePhonePrefixes } from '../hooks/usePhonePrefixes';
import FlagIcon from './FlagIcon';

export function PhonePrefixSelect({ value, onChange, className = '', style = {}, disabled = false }) {
  const { prefixes, defaultPrefix, loading } = usePhonePrefixes();
  
  // Use default if value not set
  const currentValue = value || defaultPrefix;

  if (loading) {
    return (
      <Select value="+48" disabled>
        <SelectTrigger className={className} style={style}>
          <SelectValue><FlagIcon code="pl" size={16} /> +48</SelectValue>
        </SelectTrigger>
      </Select>
    );
  }

  const currentPrefix = prefixes.find(p => p.code === currentValue);

  return (
    <Select value={currentValue} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={className} style={style}>
        <SelectValue placeholder="Prefix">
          <span className="inline-flex items-center gap-1">
            {currentPrefix && <FlagIcon code={currentPrefix.country} size={16} />} {currentValue}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-[300px]" style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}>
        {prefixes.map((prefix) => (
          <SelectItem key={prefix.code} value={prefix.code}>
            <span className="inline-flex items-center gap-1.5">
              <FlagIcon code={prefix.country} size={16} /> {prefix.code}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default PhonePrefixSelect;
